module.exports = __webpack_public_path__ + "img/shop.217d887f.webp";